(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('classToggler', classToggler);

    function classToggler(lodash) {
        return {
            restrict: 'A',
            scope: {
                toggleOn: '=?',
                toggleOff: '=?'
            },
            link: function (scope, elm, attrs) {
                const elmInstance = elm[0];
                const options = JSON.parse(attrs.classToggler);
                const classes = options.classes;

                $(elmInstance).on(options.on || 'click', (function (options, elmInstance, classes) {
                    return function(e) {
                        lodash.forEach(classes, function (oClass) {
                            const targetElm = $(options.selector);
                            if (targetElm) {
                                if (!targetElm.hasClass(oClass)) {
                                    targetElm.addClass(oClass);
                                } else {
                                    targetElm.removeClass(oClass);
                                }
                            }
                        });
                    }
                })(options, elmInstance, classes));

                scope.toggleOn = function() {
                    lodash.forEach(classes, function (oClass) {
                        const targetElm = $(options.selector);
                        if (targetElm) {
                            if (!targetElm.hasClass(oClass)) {
                                targetElm.addClass(oClass);
                            }
                        }
                    });
                };

                scope.toggleOff = function() {
                    lodash.forEach(classes, function (oClass) {
                        const targetElm = $(options.selector);
                        if (targetElm) {
                            if (targetElm.hasClass(oClass)) {
                                targetElm.removeClass(oClass);
                            }
                        }
                    });
                }
            },
        };
    }
})();